<div #alert
    role="alert"
    class="alert alert-{{type}}"
    [ngClass]="{'alert-dismissible': dismiss}">

    <ng-content></ng-content>

    <button *ngIf="dismiss"
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        (click)="dismissAlert(alert)">
        <span aria-hidden="true">
            &times;
        </span>
    </button>
  </div>
